// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3i_0Y","header":"MergedInvoice_header__1TH7A"};